import { parseWidgetDataBeforeApiRequest } from '@utils/utils';
import { useExportQueryObjectWorkflow } from '../../../hooks/useExportQueryWorklflow';
import { cleanEmptyFilters } from '../../../utils/filterUtils';
import { useBuildQueryParams, useMeasurementsList } from '../../Reports/hooks';
import { AllTypeWidgets, PivotTableTypeWidget } from '../types';

export const useExportWidget = () => {
  const { mutate: exportQueryObjectWorkflow, isPending: isExporting } = useExportQueryObjectWorkflow();

  const { data: measurements = [] } = useMeasurementsList({ filterFunc: v => v });

  const metricsWithAliases = useBuildQueryParams({
    headCellsIds: measurements.map(({ systemName }) => systemName),
    measurements,
  });

  const exportWidget = ({ widget, globalFilters }: { widget: Exclude<AllTypeWidgets, PivotTableTypeWidget>; globalFilters: any }) => {
    const parsedWidget = parseWidgetDataBeforeApiRequest({
      widget,
      metricsWithAliases,
    });
    const { top, ...rest } = parsedWidget.requests[0];

    exportQueryObjectWorkflow({
      contextFilter: cleanEmptyFilters(globalFilters),
      queryObject: {
        ...rest,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      name: widget.definition.title.title,
    });
  };

  return { exportWidget, isExporting };
};
